import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { useDebouncedEffect } from "hooks/useDebounce";
import { ReactComponent as SearchIcon } from "assets/icons/sidebar/search.icon.svg";
import TextFieldCustom from "components/TextFieldCustom/TextFieldCustom";

const TextFieldStyled = styled(TextFieldCustom)({
  width: "100%",
  boxSizing: "border-box",
  "& .input": {
    fontSize: "14px",
    padding: "0.5rem 1rem",
  },
  "& .html-input": {
    padding: "0",
  },
});

const SearchBarUnstyled = ({
  onChange,
  placeholder,
  variant = "outlined",
  corners,
  className,
  classNames = {}, // root, input, htmlInput
  value = "",
  isDisabled,
}) => {
  const { t } = useTranslation();
  const isInitialized = useRef(false);

  const [finalValue, setFinalValue] = useState(value);

  useDebouncedEffect(
    () => {
      if (!isInitialized.current) {
        isInitialized.current = true;
        return;
      }
      if (typeof onChange === "function") {
        onChange(finalValue);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [finalValue],
    300
  );

  useEffect(() => {
    setFinalValue(value);
  }, [value]);

  const handleChange = (event) => {
    setFinalValue(event.target.value);
  };

  return (
    <TextFieldStyled
      name="search-input"
      placeholder={placeholder || t("Components.Searchbar")}
      value={finalValue}
      onChange={handleChange}
      disabled={isDisabled}
      corners={corners}
      variant={variant}
      className={className}
      classNames={classNames}
      slotProps={{
        input: {
          startAdornment: <SearchIcon width={20} height={20} />,
        },
      }}
    />
  );
};

const SearchBar = styled(SearchBarUnstyled)({});
export default SearchBar;
